export default "__VITE_ASSET__B01F1gbS__"